import { Component, OnDestroy, OnInit, OnChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import { DatePipe , Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { PaymentsService } from '../../services/payments.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-vendor-payment-entry',
	templateUrl: './vendor-payment-entry.component.html',
	styleUrls: ['./vendor-payment-entry.component.scss']
})

//TODO - ADD TO PAYMENT CART
export class VendorPaymentEntryComponent implements OnInit, OnChanges {
	@Input() vendor;
	@Output() newvendordata = new EventEmitter<boolean>();

	private vendorSubscription: any;
	bankaccounts: any = [];
	payment_methods: any = [];
	paymentForm: UntypedFormGroup;
	payments: any = [];
	total_payments = 0.00;
	today = new Date();
	chargetype: any = 'Check';
	result: any = false;

	vendorInvoices: any[] = [];
	vendorCredits: any[] = [];
	vendorPayments: any[] = [];
	allocations_from: any[] = [];
	allocations_to: any[] = [];
	allocation_from_total = 0.00;
	allocation_to_total = 0.00;
	user: any = null;

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private vendorService: VendorService, public router: Router, private location: Location, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private paymentsService: PaymentsService) {}


	ngOnInit(): void {
		//vendor is required. Not on GL
		this.paymentForm = this.fb.group({
			payment_type: ['', Validators.required],
			bankaccount: ['', Validators.required],
			datepaid: [this.today, Validators.required],
			checkno: [''],
			reference: [''],
			description: ['', Validators.required],
			amount: [0.00, Validators.required],
			discount: [0, Validators.required],
		});

		this.globalSearchService.bankaccounts.subscribe((accounts: any) => {
			this.bankaccounts = accounts
			if (accounts) {
				this.paymentForm.get('bankaccount').setValue(accounts[0].accountcode);
			}
		});
		this.globalSearchService.payment_methods.subscribe((payment_methods: any) => {
			this.payment_methods = payment_methods
			if (payment_methods) {
				this.paymentForm.get('payment_type').setValue(payment_methods[0].paymentname);
			}
		});

		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});

		if (this.vendor && this.vendor.supplierid) {
			this.loadVendorTransactions();
		}
	}

	ngOnChanges() {
		if (this.vendor && this.vendor.supplierid) {
			this.loadVendorTransactions();
		}
	}

	addPayment() {
		if (this.paymentForm.valid) {

			this.payments.push(this.paymentForm.value);
			this.updateTotals();

			this.globalSearchService.showNotification('Payment added to batch', 'success', 'bottom', 'right');
			this.paymentForm.get('amount').setValue(0.00);
			this.paymentForm.get('checkno').setValue('');
			this.paymentForm.get('discount').setValue(0);
		} else {
			this.globalSearchService.getFormValidationErrors(this.paymentForm);
		}
	}

	setChargeType(event: any) {
		this.chargetype = event.value
		this.updatePaymentType(event.value)
	}

	updatePaymentType(method : any) {
		this.paymentForm.get('payment_type').setValue(method);
	}

	postPayments() {
		if (this.payments.length) {
			const allocation_data = { to: this.allocations_to };
			const data = { payments: this.payments, vendor: this.vendor, to: this.allocations_to }
			this.paymentsService.addVendorPayment(data).subscribe(result => {
				this.result = result
				this.globalSearchService.showNotification('Payment added', 'success', 'bottom', 'right');
				this.payments = [];
				this.paymentForm.get('description').setValue('');
				this.paymentForm.get('amount').setValue(0.00);
				this.paymentForm.get('discount').setValue(0);
				this.paymentForm.get('reference').setValue('');
				this.paymentForm.markAsUntouched();
				this.allocations_from = [];
				this.allocations_to = [];
				this.allocation_from_total = 0;
				this.allocation_to_total = 0;
				this.loadVendorTransactions();
				this.newvendordata.emit(this.vendor.supplierid);
			});
		}
	}

	removePayment(payment: any) {
		const index = this.payments.indexOf(payment);
		this.payments.splice(index, 1);
		this.updateTotals();
	}

	updatePaymentAmount(value: any, payment: any) {
		const index = this.payments.indexOf(payment);
		this.payments[index].amount = value;
	}
	getPaymentTotal(pay: any) {
		const discount = parseFloat(pay.amount) * (parseFloat(pay.discount) / 100);
		return (parseFloat(pay.amount) - discount);
	}

	updateTotals() {
		this.total_payments = this.payments.reduce(function(accumulator: number, payments: any) {
			const discount = parseFloat(payments.amount) * (parseFloat(payments.discount) / 100);
			return accumulator + (parseFloat(payments.amount) - discount);
		}, 0);
	}

	ngAfterViewInit() {
		//defaults
	}

	loadVendorTransactions() {
		if (this.vendor && this.vendor.supplierid) {
			this.paymentsService.getVendorAccountPayables(this.vendor.supplierid).subscribe((results: any) => {
				this.vendorInvoices = results.invoices || [];
				this.vendorCredits = results.credits || [];
				this.vendorPayments = results.payments || [];

				this.vendorInvoices.forEach((inv: any) => {
					inv.allocation = 0;
					inv.selected = false;
				});

				this.vendorCredits.forEach((cred: any) => {
					cred.allocation = 0;
					cred.selected = false;
				});

				this.vendorPayments.forEach((pay: any) => {
					pay.allocation = 0;
					pay.selected = false;
				});
			});
		}
	}

	allocationFrom(event: boolean, transaction: any) {
		if (!event) {
			const index = this.allocations_from.indexOf(transaction);
			if (index >= 0) {
				this.allocations_from.splice(index, 1);
				transaction.allocation = 0;
			}
		} else {
			if (this.allocations_from.indexOf(transaction) < 0) {
				this.allocations_from.push(transaction);
				transaction.allocation = transaction.leftto;
			}
		}
		this.updateAllocationTotals();
	}

	allocationTo(event: boolean, transaction: any) {
		if (!event) {
			const index = this.allocations_to.indexOf(transaction);
			if (index >= 0) {
				this.allocations_to.splice(index, 1);
				transaction.allocation = 0;
			}
		} else {
			if (this.allocations_to.indexOf(transaction) < 0) {
				this.allocations_to.push(transaction);
				transaction.allocation = transaction.leftto;
			}
		}
		this.updateAllocationTotals();
	}

	updateAllocationFrom(value: string, transaction: any) {
		const index = this.allocations_from.indexOf(transaction);
		if (index >= 0) {
			const amount = parseFloat(value) || 0;
			if (amount > parseFloat(transaction.leftto)) {
				transaction.allocation = parseFloat(transaction.leftto);
			} else {
				transaction.allocation = amount;
			}
		}
		this.updateAllocationTotals();
	}

	updateAllocationTo(value: string, transaction: any) {
		const index = this.allocations_to.indexOf(transaction);
		if (index >= 0) {
			const amount = parseFloat(value) || 0;
			if (amount > parseFloat(transaction.leftto)) {
				transaction.allocation = parseFloat(transaction.leftto);
			} else {
				transaction.allocation = amount;
			}
		}
		this.updateAllocationTotals();
	}

	updateAllocationTotals() {
		this.allocation_from_total = this.allocations_from.reduce(function(accumulator: number, transaction: any) {
			return accumulator + parseFloat(transaction.allocation || 0);
		}, 0);

		this.allocation_to_total = this.allocations_to.reduce(function(accumulator: number, transaction: any) {
			return accumulator + parseFloat(transaction.allocation || 0);
		}, 0);
	}

	allocatePayments() {
		if (this.allocations_from.length === 0 || this.allocations_to.length === 0) {
			this.globalSearchService.showNotification('Please select payments/credits and invoices to allocate', 'warning', 'bottom', 'right');
			return;
		}

		const from_transactions = this.allocations_from.map((t: any) => {
			return {
				id: t.id,
				supplierid: t.supplierno || this.vendor.supplierid,
				allocation: t.allocation || 0
			};
		});

		const to_transactions = this.allocations_to.map((t: any) => {
			return {
				id: t.id,
				supplierid: t.supplierno || this.vendor.supplierid,
				allocation: t.allocation || 0
			};
		});

		const userid = this.user && this.user.user ? this.user.user.userid : '';

		const data = {
			from: from_transactions,
			to: to_transactions,
			vendor: this.vendor,
			userid: userid
		};

		this.paymentsService.addVendorPaymentAllocations(data).subscribe((result: any) => {
			if (result.success) {
				this.globalSearchService.showNotification('Allocations processed successfully', 'success', 'bottom', 'right');
				this.allocations_from = [];
				this.allocations_to = [];
				this.allocation_from_total = 0;
				this.allocation_to_total = 0;
				this.loadVendorTransactions();
				this.newvendordata.emit(this.vendor.supplierid);
			} else {
				this.globalSearchService.showNotification('Error processing allocations', 'error', 'bottom', 'right');
			}
		}, (error: any) => {
			this.globalSearchService.showNotification('Error processing allocations', 'error', 'bottom', 'right');
		});
	}

}
